<template>
  <div class="Register-container">

    <div v-if="!success" class="Register-content">
      <img :src="logo" class="Register-logo" alt="Tecate 0.0" />
      <h2 class="Register-text">Nueva tecate 0.0</h2>
      <p class="Register-text2">
        Necesitas 0.0 pretextos <br />
        para tomarte una fría.
      </p>
      <p class="Register-text2-desktop">
        Necesitas 0.0 pretextos para tomarte una fría.
      </p>
      <img :src="banner" class="Register-banner" alt="Banner Tecate 0.0" />
      <p class="Register-text3">
        REGISTRATE PARA PROBAR ANTES <br />
        QUE NADIE LA NUEVA TECATE 0.0. <br />
      </p>
      <p class="Register-text3-desktop">
        REGISTRATE PARA PROBAR ANTES QUE NADIE LA NUEVA TECATE 0.0.
      </p>
      <p class="Register-text4">Dirección de correo electrónico:</p>
      <input class="Register-email-input" v-model="email" placeholder="Dirección de correo Electrónico" />
      <small class="error-message" v-if="emailError">Debes ingresar un correo válido</small>
      <GoogleButton :tycos="checked" :privacy="checkedPrivacy" @errorTycos="(ev) => (tycosError = ev)"
        @errorPrivacy="(ev) => (privacyError = ev)" @success="onSuccess($event)" @loading="(ev) => loading = ev">
      </GoogleButton>

      <FacebookButton :tycos="checked" :privacy="checkedPrivacy" @errorTycos="(ev) => (tycosError = ev)"
        @errorPrivacy="(ev) => (privacyError = ev)" @success="onSuccess($event)" @loading="(ev) => loading = ev">
      </FacebookButton>

      <div class="Register-button" @click="onRegister()">
        <span>Registrarme</span>
      </div>
      <div class="register-politics">
        <div>
          <input type="checkbox" id="tycos" name="tycos" :class="tycosError ? 'error' : ''" :value="checked"
            @click="onChecked()" />
          <label class="Register-text5" for="tycos">
            Al registrarte aceptas los
            <a class="link" @click="onOpenTycos($event)">términos y condiciones</a></label>
        </div>
        <div>
          <input type="checkbox" id="tycos" name="tycos" :class="privacyError ? 'error' : ''" :value="checkedPrivacy"
            @click="onCheckedPrivacy()" />
          <label class="Register-text5" for="tycos">
            Al registrarte aceptas el
            <a class="link" @click="onOpenPrivacity($event)">aviso de privacidad</a></label>
        </div>
      </div>

      <small class="error-message" v-if="tycosError">Debes aceptar los términos y condiciones para continuar</small>
      <small class="error-message" v-if="privacyError">Debes aceptar el aviso de privacidad para continuar</small>
    </div>
    <div class="Register-content" v-else>
      <img :src="logo" class="Register-logo" alt="Tecate 0.0" />

      <h2 class="Register-text">Gracias por Registrarte</h2>
    </div>
    <div v-if="loading" class="loading-content">
      <div class="lds-default">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  </div>
</template>

<script>
import banner from "@/assets/TECATE00_REGISTER.jpg";
import logo from "@/assets/LOGO_NEGRO.png";
import google from "@/assets/google.png";
import FacebookButton from "@/components/FacebookButton";
import GoogleButton from "@/components/GoogleButton";
import axios from "axios";
import { sha256 } from "js-sha256";
import tagFunctions from "@/utils/tagFunctions.js";
import { generateGuid } from '@/utils/guid.js';
import moment from 'moment';
const AUTHURL =
  "https://eu02.api.heiway.com/production/portal/nativeoauthprovider/oauth2/token";
const BASIC_TOKEN =
  "MTgyOGU4MDdmZjA1ZTkwNmRkMjM2Y2FhNjM3ZGZhOGU6MGVhYTU5MzFmOTA2ZjZhZWVmNmRmYzhlOGYzNTRmYmI=";

const EVENT_URL =
  "https://eu02.api.heiway.com/production/portal/sfmc/v1/event/message";
const ACCOUNT_ID = "534002103";

const TESTAPiEVENT = "APIEvent-f214db21-9e83-c8ab-1d73-ae97d4beffa1";
const PROAPIEVENT = "APIEvent-befe53c6-cdf4-f644-42b3-a657e9e4c297";

export default {
  name: "Register",
  components: {
    FacebookButton,
    GoogleButton,
  },
  data() {
    return {
      banner,
      logo,
      google,
      checked: false,
      checkedPrivacy: false,
      tycosError: false,
      showModal: false,
      email: "",
      emailError: false,
      privacyError: false,
      loading: false,
      success: false
    };
  },
  mounted() { 
    tagFunctions.user_interactionPush(
      "view",
      "registro",
      "home"
    );
  },
  methods: {
    onChecked() {
      this.checked = !this.checked;
      if (this.checked) {
        this.tycosError = false;
      }
    },

    onCheckedPrivacy() {
      this.checkedPrivacy = !this.checkedPrivacy;
      if (this.checkedPrivacy) {
        this.privacyError = false;
      }
    },
    async onRegister() {
      if (!this.checked) {
        this.tycosError = true;
        return;
      }

      if (!this.checkedPrivacy) {
        this.privacyError = true;
        return;
      }

      if (!this.validateEmail(this.email)) {
        this.emailError = true;
        return;
      }
      this.tycosError = false;
      this.privacyError = false;
      this.loading = true
      
    
      await this.xeerpaRequestFM(this.email);
      await this.sendEmail(this.email);
      localStorage.setItem("user", sha256(this.email));
      this.loading = false
      this.success = true;
      setTimeout(() => {
        this.$emit("close", true);
      }, 2000);
      // await this.onSuccess();
      tagFunctions.evRegisterPush("Registrarme");
      pintrk('track', 'signup', { property: 'Registrarme' });
    },
    onOpenTycos(ev) {
      ev.preventDefault();
      this.$emit("openTerms", true);
    },

    onOpenPrivacity(ev) {
      ev.preventDefault();
      this.$emit("openPrivacy", true);
    },
    async onSuccess(email = null) {
      this.tycosError = false;
      this.privacyError = false;
      if (email) {
        this.email = email;
        localStorage.setItem("user", sha256(this.email));
      } else {
        localStorage.setItem("user", sha256(this.email));
      }
      this.loading = false
      this.success = true;
      await this.sendEmail(this.email);
      setTimeout(() => {
        this.$emit("close", true);
      }, 2000);


      await this.sendEmail(this.email);
    },
    validateEmail(email) {
      return String(email)
        .toLowerCase()
        .match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
    },
    async sendEmail(email) {
      this.emailError = false;
      const resp = await axios.post(
        `https://prod-ws-tecateapi.azurewebsites.net/api/Campaign/00/${email}`
      );
      await this.requestAuthToken();
      return resp;
    },
    async requestAuthToken() {
      const resp = await axios.post(
        `${AUTHURL}`,
        "grant_type=client_credentials&scope=read:write",
        {
          headers: {
            Authorization: `Basic ${BASIC_TOKEN}`,
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      );
      await this.triggerJourney(this.email, resp.data.access_token);
    },
    async triggerJourney(email, access_token) {
      const guid = generateGuid();
      let payload = {
        contactKey: sha256(email),
        eventDefinitionKey: PROAPIEVENT,
        data: {
          engagement_Key: guid,
          consumer_Key: sha256(email),
          email_Address: email,
          locale: "es-mx",
          created_date: moment().format("MM/DD/YYYY"),
        },
      };
      const resp = await axios.post(`${EVENT_URL}`, payload, {
        headers: {
          Authorization: "Bearer " + access_token,
          "Content-Type": "application/json",
          Accept: "application/text",
          "X-Heineken-SFMC-Account-Id": ACCOUNT_ID,
        },
      });
      `https://prod-ws-tecateapi.azurewebsites.net/api/Campaign/00/${email}`

      return resp;
    },

    async xeerpaRequestFM(email) {
      this.$emit('loading', true)
      const hash = sha256(email);
      const resp = await axios.get(`https://cuamoc.xeerpa.com:8443/discoveruser?clientId=6149a1372dfd6f0d347b6458&clientPwd=yyipHjnqJg&appId=63e0e6ada94e170f88ad0973&socialNetwork=FM&userId=${email}&id=${hash}&robinson=false`, {
        params: {
          data: JSON.stringify({ email })
        }
      });
      return resp
    }
  },
};
</script>
<style lang="scss" scoped>
@import "~@/styles/Register.scss";
</style>

<style>
.lds-default {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}

.lds-default div {
  position: absolute;
  width: 6px;
  height: 6px;
  background: #fff;
  border-radius: 50%;
  animation: lds-default 1.2s linear infinite;
}

.lds-default div:nth-child(1) {
  animation-delay: 0s;
  top: 37px;
  left: 66px;
}

.lds-default div:nth-child(2) {
  animation-delay: -0.1s;
  top: 22px;
  left: 62px;
}

.lds-default div:nth-child(3) {
  animation-delay: -0.2s;
  top: 11px;
  left: 52px;
}

.lds-default div:nth-child(4) {
  animation-delay: -0.3s;
  top: 7px;
  left: 37px;
}

.lds-default div:nth-child(5) {
  animation-delay: -0.4s;
  top: 11px;
  left: 22px;
}

.lds-default div:nth-child(6) {
  animation-delay: -0.5s;
  top: 22px;
  left: 11px;
}

.lds-default div:nth-child(7) {
  animation-delay: -0.6s;
  top: 37px;
  left: 7px;
}

.lds-default div:nth-child(8) {
  animation-delay: -0.7s;
  top: 52px;
  left: 11px;
}

.lds-default div:nth-child(9) {
  animation-delay: -0.8s;
  top: 62px;
  left: 22px;
}

.lds-default div:nth-child(10) {
  animation-delay: -0.9s;
  top: 66px;
  left: 37px;
}

.lds-default div:nth-child(11) {
  animation-delay: -1s;
  top: 62px;
  left: 52px;
}

.lds-default div:nth-child(12) {
  animation-delay: -1.1s;
  top: 52px;
  left: 62px;
}

@keyframes lds-default {

  0%,
  20%,
  80%,
  100% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.5);
  }
}

.loading-content {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
}
</style>
